<template>
  <div class="app ma-4">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />

    <v-sheet v-show="showSkeleton" class="pa-3 mr-4">
      <v-row>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="heading" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
    </v-sheet>

    <div v-show="!showSkeleton">
      <div class="text-h4 mb-4" v-if="!edicao">Cadastro de Pausa</div>

      <v-form ref="form">
        <v-row>
          <v-col>
            <v-text-field
              outlined
              dense
              label="Descrição"
              counter="30"
              v-model="form.description"
              :disabled="permissaoVisualizar"
              :error-messages="descriptionErrors"
              @input="$v.form.description.$touch()"
              @blur="$v.form.description.$touch()"
            />
          </v-col>
          <v-col>
            <v-text-field
              outlined
              dense
              label="Código"
              counter="10"
              v-model="form.codigo"
              :disabled="desativado || permissaoVisualizar"
              :error-messages="codigoErrors"
              @input="$v.form.codigo.$touch()"
              @blur="$v.form.codigo.$touch()"
            />
          </v-col>
          <v-col>
            <v-text-field
              outlined
              dense
              label="Duração(HH:mm)"
              hint="Formato: HH:mm"
              persistent-hint
              v-model="form.duration"
              :disabled="permissaoVisualizar"
              :error-messages="durationErrors"
              @input="$v.form.duration.$touch()"
              @blur="$v.form.duration.$touch()"
            />
          </v-col>
        </v-row>
        <FixedButtons
          @salvar="salvar"
          @cancelar="cancelar"
          :pararLoader="pararLoader"
          :disableSaveButton="permissaoVisualizar"
        />
      </v-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'

import Snackbar from '@/componentes/Snackbar'
import FixedButtons from '@/componentes/FixedButtons'
import { registerVuexModule } from '@/utils/vuexUtils'
import { obtainUserPermissions } from '@/utils/obtainUserPermissions'

import pausaHttpService from '../_services/pausaHttpService'
import { validateData, validateComputed } from '../_validates/validatesPausas'
import pausasStore from '../_store'

export default {
  name: 'CadastroOperador',
  props: {
    edicao: String,
    _id: String,
  },
  components: { Snackbar, FixedButtons },
  mixins: [validationMixin],

  data: () => ({
    text: '',
    snackbar: false,
    showSkeleton: false,
    desativado: false,
    show: false,
    form: {
      description: '',
      codigo: '',
      duration: '',
    },
    pararLoader: {
      parar: false,
    },
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...validateComputed,
    ...mapGetters('cadastroPausaModuleCallCenterStore', ['getPausa']),
  },

  async created() {
    this.showSkeleton = true

    registerVuexModule(this.$store, 'cadastroPausaModuleCallCenterStore', pausasStore)

    if (this.edicao === 'true') {
      this.desativado = true
      this.form = Object.assign({}, this.getPausa)
    }

    const arrayPermissions = this.arrayPermissionsFromLocalStorage()
    if (arrayPermissions.includes(process.env.VUE_APP_CALLCENTER_CADASTRO_PAUSA_VISUALIZAR_CONDICIONADO)) {
      this.permissaoVisualizar = true
    }else{
      this.permissaoVisualizar = false

    }

    this.showSkeleton = false
  },

  methods: {
    ...obtainUserPermissions,

    cancelar() {
      this.$router.push({ name: 'Pausa' })
    },

    async salvar() {
      this.form.senhaWeb = this.form.senhaRamal
      this.pararLoader.parar = false

      this.$v.$touch()
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        this.pararLoader.parar = true
        return
      }
      try {
        if (this.edicao === 'true') {
          await pausaHttpService.putPausa(this._id, this.form)
        } else {
          await pausaHttpService.postPausa(this.form)
        }
        this.$router.push({ name: 'Pausa' })
      } catch (error) {
        let key = Object.keys(error.response.data)
        this.text = error.response.data[key[0]]
        this.snackbar = true
        this.pararLoader.parar = true
      }
    },
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
